module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "field is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Search Users"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }, _vm.doSearch]
    }
  })]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('paginator', {
    attrs: {
      "current_page": _vm.current_page,
      "total_pages": _vm.total_pages
    },
    on: {
      "set-page": _vm.setPage
    }
  }), _vm._v(" "), _c('data-table', {
    attrs: {
      "data-set": _vm.users,
      "page-length": 50,
      "allow-search": false,
      "columns": [{
          name: 'Account',
          prop: 'account_number',
          type: 'number'
        },
        {
          name: 'User',
          prop: ['first_name', 'last_name', 'email'],
          type: 'text'
        },
        {
          name: 'Created',
          prop: 'created_at',
          type: 'date',
          filter: ['moment', ['from', 'now']]
        },
        {
          name: 'Updated',
          prop: 'updated_at',
          type: 'date',
          filter: ['moment', ['from', 'now']]
        } ]
    },
    scopedSlots: _vm._u([{
      key: "column_Account",
      fn: function(props) {
        return [_vm._v("\n      " + _vm._s(props.row.account_number ? props.row.account_number : 'N/A') + "\n    ")]
      }
    }, {
      key: "column_User",
      fn: function(props) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'user',
              params: {
                id: props.row.id
              }
            }
          }
        }, [_vm._v("\n        " + _vm._s(props.row.first_name) + " " + _vm._s(props.row.last_name) + "\n        "), _c('br'), _vm._v("\n        " + _vm._s(props.row.email) + "\n      ")])]
      }
    }])
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "control"
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("\n        Search\n      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68d429da"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/views/users/UserList.vue
// module id = 548
// module chunks = 0